import React, { createContext, useContext, useState, useCallback, useMemo } from "react";
import axiosInstance from "../AxiosInstance";
import config from "../config/config";
import {
    getClientTimeZone,
    getClientTodayMMDDYYYY,
} from "../util_functions/helpers";
import { useJobCreate } from "./JobCreateContext";

const TaskSenseContext = createContext(null);

export const TaskSenseProvider = ({ children }) => {

    const { getJobCreateIdFromCookies } = useJobCreate();
    const [isCrafting, setIsCrafting] = useState(false);
    const [error, setError] = useState(null);
    const [lastPayload, setLastPayload] = useState(null);

    const clientTimeZone = useMemo(() => getClientTimeZone(), []);
    const clientToday = useMemo(
        () => getClientTodayMMDDYYYY(clientTimeZone),
        [clientTimeZone]
    );

    const craftJobFromPrompt = useCallback(
  async (description, primaryLocation) => {
    const jobCreateId = getJobCreateIdFromCookies();
    console.log("[TaskSense] jobCreateId from cookies:", jobCreateId);
    console.log("[TaskSense] clientTimeZone:", clientTimeZone);
    console.log("[TaskSense] clientToday:", clientToday);
    console.log("[TaskSense] Primary Location:", primaryLocation);
    if (!jobCreateId) {
      throw new Error("Missing jobCreateId. Please click Next on location first.");
    }

    setIsCrafting(true);
    setError(null);

    const payload = {  jobCreateId, description, primaryLocation, clientTimeZone, clientToday };

    try {
      const response = await axiosInstance.post(
        `/v1/task-sense/craft`,  
        payload
      );

      const data = response?.data ?? null;
      setLastPayload(data);
      return data;
    } catch (err) {
      console.error("[TaskSense] craftJobFromPrompt error:", err);
      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "TaskSense request failed";

      const normalizedError = new Error(message);
      setError(normalizedError);
      throw normalizedError;
    } finally {
      setIsCrafting(false);
    }
  },
  [getJobCreateIdFromCookies, clientTimeZone, clientToday]
);


    return (
        <TaskSenseContext.Provider
            value={{
                isCrafting,
                error,
                clientTimeZone,
                clientToday,
                lastPayload,
                craftJobFromPrompt,
            }}
        >
            {children}
        </TaskSenseContext.Provider>
    );
};

export const useTaskSense = () => {
    const ctx = useContext(TaskSenseContext);
    if (!ctx) {
        throw new Error("useTaskSense must be used within a TaskSenseProvider");
    }
    return ctx;
};
